import { styled } from '@ringcentral/juno';
import { onMobile } from '@/core/sc';

export const Section = styled.div`
  &:not(:first-child) {
    margin-top: 28px;

    ${onMobile} {
      margin-top: 24px;
    }
  }
`;
